module.exports = __webpack_public_path__ + "img/bf.48eb94de.svg";